import React from "react";

export const IconCabaret = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 28 28"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m1.1666 25.744h25.667m-23.186-8.8122h3.2511c3.08 0 4.8766-4.1922 4.8766-13.347m-4.4489 13.347 1.7111 8.8122m-2.9089-8.8122 1.2833-3.7644m16.94 3.7644h-3.2511c-3.08 0-4.8767-4.1922-4.8767-13.347m4.4489 13.347-1.7111 8.8122m2.9089-8.8122-1.2834-3.7644m3.7645 12.577h-20.704v-19.763c0-1.3689 1.1122-2.4811 2.4811-2.4811h15.742c1.3689 0 2.4811 1.1122 2.4811 2.4811v19.763z"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconCabaret;
